import svsfl from './svsfl.jpg';

export const posters = {
  svsfl,
};
